module.exports = __webpack_public_path__ + "static/media/WheelGoodLogo.3e8049fc.png";